import { Fragment, useContext } from "react";
import PropTypes from "prop-types";
import "app/pages/Booking/booking.scss";
import { Navigate, Route, Routes, useMatch } from "react-router-dom";
import { QUOTATION_STATUS_VALIDE, STRATEGY } from "app/constants";
import { connect } from "react-redux";
import BookingPrivateRoute from "app/pages/.shared/BookingPrivateRoute";
import { strategyShape } from "app/utils/propTypes";
import {
	AsyncAuthBookingContainer,
	AsyncBookingAsideContainer,
	AsyncConfirmationContainer,
	AsyncQuotationContainer,
} from "app/routes";
import PaymentContainer from "app/pages/Booking/Payment/PaymentContainer";
import { isWhiteLabel } from "app/reducers/brandSelector";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import CollapsableHolidaySummaryContainer from "app/pages/Booking/HolidaySummary/CollapsableHolidaySummary/CollapsableHolidaySummaryContainer";
import QueriesParser from "app/pages/.shared/QueriesParser/QueriesParser";
import SmartDPHotelDescriptionContainer from "app/pages/SmartDP/Quote/HotelDescription/SmartDPHotelDescriptionContainer";
import { bindActionCreators } from "redux";
import { fetchProductStressMarketingsData } from "app/pages/StressMarketing/stressMarketingActionCreators";
import { isFlashsale, isGlobalCampaignProduct } from "app/pages/FicheProduit/ficheProduitSelector";
import RequireSignupFirst from "app/pages/Auth/RequireSignupFirst";
import BookingInformationContainer from "app/pages/.shared/BookingInformation/BookingInformationContainer";

const SmartDPBooking = ({
	strategy,
	isWhiteLabel,
	// ficheProduit,
	isFlashsale,
	isGlobalCampaignProduct,
	quotationStatus,
	// fetchProductStressMarketingsData = () => {},
}) => {
	const { resolution } = useContext(AppGlobalsContext);

	const isMobile = [RESOLUTION.SMALL, RESOLUTION.MEDIUM].includes(resolution);

	const isSDPConfirmationPage = useMatch("/sdp/booking/confirmation");

	// il faut verifier le quotationStatus pour eviter pb de sticky sur ios mobile
	const showHolidaySummary =
		!isSDPConfirmationPage && isMobile && QUOTATION_STATUS_VALIDE.includes(quotationStatus);

	// disabled for now because of a certificat issue FBR-3303
	// const destinationAirportIATA = ficheProduit?.geography?.destinationAirportIATA;
	// useEffect(() => {
	// 	if (destinationAirportIATA) {
	// 		fetchProductStressMarketingsData(destinationAirportIATA);
	// 	}
	// }, [destinationAirportIATA]);

	const shouldNotProtectedPaymentRoute =
		strategy === STRATEGY.TRANSACTION_FIRST ||
		([STRATEGY.AUTH_FLASHSALE, STRATEGY.NAVIGATION_FIRST, STRATEGY.OAUTH].includes(strategy) &&
			!isFlashsale) ||
		(strategy === STRATEGY.AUTH_GC && !isGlobalCampaignProduct);

	const shouldProtecteQuotationRoute =
		(strategy === STRATEGY.AUTH_FLASHSALE && isFlashsale) ||
		(strategy === STRATEGY.AUTH_GC && isGlobalCampaignProduct);

	return (
		<Fragment>
			<div className="booking">
				<Routes>
					<Route
						path="/auth"
						element={
							isWhiteLabel ? (
								<AsyncAuthBookingContainer />
							) : (
								<Navigate to="/not-found" />
							)
						}
					/>
				</Routes>

				<div className="booking__container">
					<div className="booking__main">
						<Routes>
							<Route path="/quote" element={<SmartDPHotelDescriptionContainer />} />
						</Routes>

						<Routes>
							<Route
								path="/quote"
								element={
									<QueriesParser>
										{shouldProtecteQuotationRoute ? (
											<RequireSignupFirst
												renderComponent={props => {
													return <AsyncQuotationContainer {...props} />;
												}}
											/>
										) : (
											<AsyncQuotationContainer />
										)}
									</QueriesParser>
								}
							/>
							<Route
								path="/payment"
								element={
									// eslint-disable-next-line no-nested-ternary
									shouldNotProtectedPaymentRoute ? (
										<PaymentContainer />
									) : (
										<BookingPrivateRoute authPath="../auth">
											<PaymentContainer />
										</BookingPrivateRoute>
									)
								}
							/>
							<Route path="/confirmation" element={<AsyncConfirmationContainer />} />
						</Routes>
					</div>

					<div className="booking__aside">
						<Routes>
							<Route
								path="/quote"
								element={
									<AsyncBookingAsideContainer
										showQuotationCTAButton
										showPaymentDescriptionTerms
										showContactUs
										showPriceDetails
									/>
								}
							/>
							<Route
								path="/payment"
								element={
									<AsyncBookingAsideContainer
										showProductPicture
										showContactUs
										showPriceDetails
									/>
								}
							/>
							<Route
								path="/confirmation"
								element={<AsyncBookingAsideContainer showProductPicture />}
							/>
						</Routes>
					</div>
				</div>

				{showHolidaySummary && (
					<Routes>
						<Route
							path="/quote"
							element={
								<div className="booking__holiday-summary">
									<CollapsableHolidaySummaryContainer />
								</div>
							}
						/>
						<Route
							path="/payment"
							element={
								<div className="booking__holiday-summary">
									<CollapsableHolidaySummaryContainer />
								</div>
							}
						/>
					</Routes>
				)}
			</div>

			<div className="booking-information__container">
				<div className="booking-information__content">
					<BookingInformationContainer showProductUsefulInformation />
				</div>
			</div>
		</Fragment>
	);
};

SmartDPBooking.propTypes = {
	strategy: strategyShape,
	ficheProduit: PropTypes.object,
	isWhiteLabel: PropTypes.bool,
	quotationStatus: PropTypes.string,
	isFlashsale: PropTypes.bool,
	isGlobalCampaignProduct: PropTypes.bool,
	fetchProductStressMarketingsData: PropTypes.func,
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			fetchProductStressMarketingsData,
		},
		dispatch
	);

const mapStateToProps = state => {
	return {
		ficheProduit: state.ficheProduit,
		isFlashsale: isFlashsale(state),
		strategy: state.partner.strategy,
		isWhiteLabel: isWhiteLabel(state),
		isGlobalCampaignProduct: isGlobalCampaignProduct(state),
		quotationStatus: state.quotation.status,
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SmartDPBooking);
